import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useCampaignScreensPathsChecker } from '@/components/CampaignCreator/hooks/useCampaignScreensPathsChecker';
import { AlertWrapper } from '@/components/CampaignCreator/styled';
import { BillingPaths, pathsParams } from '@/services/dictionaries/Paths';
import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';
import { getGeneralInfo } from '@/store/account/actions';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { CampaignErrorNames } from '@/store/campaignCreator/types';
import { Alert } from '@dev/ee-components';
import { Link } from '@material-ui/core';

export const Alerts = (): JSX.Element => {
    const { t } = useTranslation();
    const { isRecipientsCountLoading, errors } = useSelector(getCampainCreatorStore);
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { isPilotPlan, productCode } = useCurrentPlanStatus();
    const { UserName } = useSelector(getGeneralInfo);

    if (isDetailsScreen || isRecipientsCountLoading) {
        return null;
    }

    return (
        <>
            {(errors?.[CampaignErrorNames.NO_RECIPIENTS] || errors?.[CampaignErrorNames.NO_TARGETS_SELECTED]) && (
                <AlertWrapper>
                    <Alert severity="error" body={t('tryingtosendcampaignto0recipients')} />
                </AlertWrapper>
            )}
            {errors?.[CampaignErrorNames.OUT_OF_RECIPIENTS_LIMIT] && (
                <AlertWrapper>
                    <Alert severity="error" body={t('numberofrecipientsbiggerthanemaillimit')} />
                </AlertWrapper>
            )}
            {errors?.[CampaignErrorNames.NOT_ENOUGH_RECIPIENTS] && (
                <AlertWrapper>
                    <Alert severity="error" body={t('numberofrecipientsnotenoughforab')} />
                </AlertWrapper>
            )}
            {isPilotPlan && (
                <AlertWrapper className="alert-text-justify-between">
                    <Alert
                        severity="info"
                        body={
                            <Trans
                                i18nKey="pilotplan_warning"
                                values={{
                                    accountemail: UserName,
                                }}
                                components={{
                                    l: (
                                        <Link
                                            href={BillingPaths.BillingPlanList.replace(
                                                pathsParams.productCode,
                                                productCode?.toLowerCase?.()
                                            )}
                                        />
                                    ),
                                }}
                            />
                        }
                    />
                </AlertWrapper>
            )}
        </>
    );
};
